import React, { useMemo } from 'react';
import { colors, colorUtils } from '@prisjakt/ui-base/';
import { RangeAggregationBucket } from '../../../../../../types';
import * as S from './styles';

type RangeT = [number, number];

/**
 * Returns the percentage with which range2 covers range1.
 * @return Float between [0-1].
 */
const getRangeOverlap = (range1: RangeT, range2: RangeT): number => {
  if (
    range1[0] === range1[1] ||
    range2[0] === range2[1] ||
    range1[0] >= range2[1] ||
    range1[1] <= range2[0]
  ) {
    return 0;
  }
  if (range1[0] >= range2[0] && range1[1] <= range2[1]) {
    return 1;
  }
  const range1Size = range1[1] - range1[0];
  const overlap =
    Math.min(range1[1], range2[1]) - Math.max(range1[0], range2[0]);
  return overlap / range1Size;
};

type PitComponentProps = {
  style: object;
  children: number;
  getBucket: (index: number) => RangeAggregationBucket | undefined;
  largestBucketCount: number;
  selectedValues: number[];
};

/**
 * Rheostat custom histogram bucket component.
 */
const Pit = ({
  getBucket,
  largestBucketCount,
  selectedValues,
  children,
}: PitComponentProps) => {
  const pit = getBucket(children);
  const { from, to, count } = pit || { from: 0, to: 0, count: 0 };
  const [selectedFrom, selectedTo] = selectedValues;
  const pitStyle = useMemo(
    () => ({
      // Exclude rheostat styling, we use flexbox
      // ...style,
      height: largestBucketCount > 0 ? 40 * (count / largestBucketCount) : 0,
      backgroundColor: colorUtils.blendHexColors(
        colors.darkGray1,
        colors.darkBlue1,
        getRangeOverlap([from, to], [selectedFrom, selectedTo])
      ),
    }),
    [count, largestBucketCount, from, to, selectedFrom, selectedTo]
  );
  return <S.SliderPit style={pitStyle} />;
};

export default Pit;
